module.exports = __webpack_public_path__ + "img/sk-partners-forbes.50ecc534.png";